import { combineReducers } from "redux";

import sidebar from "./sidebarReducers";
import layout from "./layoutReducer";
import theme from "./themeReducer";
import poinsettia from "./poinsettiaReducer";
import mum from "./mumReducer";
import auth from "./authReducer";
import machine from "./machineReducer";
import tasks from "./taskReducer";
import production from "./productionReducer";
import pSettings from "./pSettingsReducer";

import { reducer as toastr } from "react-redux-toastr";

export default combineReducers({
  auth,
  sidebar,
  layout,
  theme,
  poinsettia,
  mum,
  toastr,
  machine,
  tasks,
  production,
  pSettings
});
